'use strict';

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {ERROR, SAVED_FILTER_VERSION} from '../../../consts';
import { SUBSCRIPTION } from '../../../app/Search/actionTypes';
import getDictionary from '../../../utils/dictionaries';
import { pureFilter } from '../../../utils/urls';
import {
  saveSubscriptionSearchFilter
} from '../../../app/Search/actions';

import Pills from '../Pills';

class SubscriptionSearchForm extends Component {
  constructor (props) {
    super(props);

    this.userEmail = props.user.getIn(['data', 'email'], '') || '';

    this.state = {
      isOpen: false,
      process: false,

      email: this.userEmail,
      notify: false,
      errors: []
    };

    this.handlerOpen = this.handlerOpen.bind(this);
    this.handlerClose = this.handlerClose.bind(this);
    this.handlerChangeEmail = this.handlerChangeEmail.bind(this);
    this.handlerSave = this.handlerSave.bind(this);

    this.clearErrors = () => this.setState({errors: []});
  }

  handlerOpen () {
    this.props.eventOnOpen();

    this.setState({
      isOpen: true
    });
  }

  handlerClose (e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      isOpen: false,
      email: this.userEmail,
      notify: false,
      errors: []
    });
  }

  handlerChangeEmail (e) {
    const email = e.target.value;
    this.setState({
      email
    });

    if (email) {
      this.clearErrors();
    }
  }

  handlerSave () {
    const email = this.state.email.trim();

    if (email) {
      const {section, domain, filter} = this.props;

      this.setState({
        process: true
      });

      this.props.saveSubscriptionSearchFilter(
        section.get('dealType'),
        section.get('realtyType'),
        {
          formatVersionId: SAVED_FILTER_VERSION,
          filter: JSON.stringify(pureFilter(filter).set('regionId', domain.get('regionId')).toJSON()),
          email: email
        }
      ).then(action => {
        const state = {
          process: false,
          email: this.userEmail,
          notify: false,
          errors: []
        };

        if (action.type === SUBSCRIPTION + ERROR) {
          state.errors = action.payload ? action.payload.map(err => err.message) : [];
        } else {
          state.notify = true;
        }

        this.setState(state);
      });
    }
  }

  renderNotify () {
    return (
      'На электронный адрес: ' + this.state.email + ' в течение 5 минут будет выслано ' +
      'письмо с инструкцией по активации подписки'
    );
  }

  renderForm () {
    const {process, errors, email} = this.state;

    return (
      <div>
        <span className='info'>
          Свежие предложения, подходящие под текущий запрос, будут отправлятся по мере их поступления.
        </span>

        <Pills
          wrapperClassName='subscription-pill-wrp'
          domain={this.props.domain}
          dictionary={this.props.dictionary}
          filter={this.props.filter}
          enableClearAll={false}
          enableClearItem={false}
        />

        <div className={'email-box' + (errors.length ? ' error' : '')}>
          <input
            type='email'
            className='text-base'
            value={email}
            placeholder='Введите ваш email'
            onChange={this.handlerChangeEmail}
          />

          { errors.map(err => (<span className='error-message'>{err}</span>)) }
        </div>

        <div className='controls'>
          {
            process ? (
              <span>сохранение подписки ...</span>
            ) : (
              <button
                type='button'
                disabled={!email.length}
                onClick={this.handlerSave}
                className='btn btn-primary'
              >
                ПОДПИСАТЬСЯ
              </button>
            )
          }
        </div>
      </div>
    );
  }

  render () {
    const {isOpen, notify} = this.state;
    const className = 'form-container form' +
      (this.state.errors.length ? ' error' : '') +
      (notify ? ' disable-control' : '');

    return (
      <Fragment>
        <span className='link-base saved-search' onClick={this.handlerOpen}>
          { this.props.children }
        </span>

        <div className={'modal full-screen' + (isOpen ? ' open fade in' : '')}>
          {
            isOpen && (
              <div className='modal-dialog full-screen'>
                <div className='modal-content animate-top'>
                  <div className='modal-box search-subscription-modal'>
                    <button type='button' className='close' onClick={this.handlerClose}>×</button>

                    <div className={className}>
                      <h2 className='header'>Подписка на новые объявления</h2>

                      { notify ? this.renderNotify() : this.renderForm() }
                    </div>

                  </div>
                </div>
              </div>
            )
          }
          <TransitionGroup>
            {
              isOpen &&
              <CSSTransition key={'modal-backdrop'} appear classNames='fade' timeout={300}>
                <div className='modal-backdrop full-screen' />
              </CSSTransition>
            }
          </TransitionGroup>
        </div>
      </Fragment>
    );
  }
}

SubscriptionSearchForm.propTypes = {
  user: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  domain: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired,
  dictionary: PropTypes.object.isRequired,

  children: PropTypes.any.isRequired,

  saveSubscriptionSearchFilter: PropTypes.func.isRequired,
  eventOnOpen: PropTypes.func
};

SubscriptionSearchForm.defaultProps = {
  eventOnOpen: () => {}
};

function mapStateToProps (state) {
  return {
    user: state.get('user'),
    domain: state.get('domain'),
    section: state.get('section'),
    dictionary: getDictionary(state.get('dictionaries'))
  };
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    saveSubscriptionSearchFilter
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionSearchForm);



// WEBPACK FOOTER //
// ./src/ui/Controls/Subscriptions/SubscriptionSearchForm.jsx